import PrivateRoomPieceRecords from "./PrivateRoomPieceRecords";

export default PrivateRoomPieceRecords;
